import { ValidationRuleTemplateCategory } from '@recurrency/core-api-schema/dist/common/enums';
import { ValidationRuleCategories } from '@recurrency/core-api-schema/dist/validationRules/common';
import copy from 'copy-to-clipboard';

export const INPUT_SQL_CTE = `WITH inputs AS (
  SELECT item_id, location_id
  FROM @DB_SCHEMA.search_planning
)`;

export const getTemplateCategoryTitle = (category: ValidationRuleTemplateCategory) => {
  switch (category) {
    case ValidationRuleTemplateCategory.DataQuality:
      return 'Data Quality';
    case ValidationRuleTemplateCategory.DemandSignalShifts:
      return 'Demand Shift Signals';
    case ValidationRuleTemplateCategory.HitAndCustomerExpectations:
      return 'Hit and Customer Exceptions';
    case ValidationRuleTemplateCategory.MismatchedStockingStrategy:
      return 'Mismatched Stocking Strategy';
    case ValidationRuleTemplateCategory.VendorSupplierExpectations:
      return 'Vendor/Supplier Exceptions';
    case ValidationRuleTemplateCategory.DefaultDailyWorkflow:
      return 'Default Daily Workflow';
    default:
      // Default to most popular
      return 'Most Popular';
  }
};

export const getTemplateCategoryDescription = (category: ValidationRuleTemplateCategory) => {
  switch (category) {
    case ValidationRuleTemplateCategory.DataQuality:
      return 'Items with missing, invalid, inconsistent setup data or ERP values.';
    case ValidationRuleTemplateCategory.DemandSignalShifts:
      return 'Items showing recent changes in usage, sales, or forecast patterns that may require updates to planning logic.';
    case ValidationRuleTemplateCategory.HitAndCustomerExpectations:
      return 'Items with low usage. Few hits, few customers, or inconsistent activity that may not justify current stocking levels.';
    case ValidationRuleTemplateCategory.MismatchedStockingStrategy:
      return "Items where reorder settings (like Min/Max or UOM) don't align with how the item is actually sold, ordered, or consumed.";
    case ValidationRuleTemplateCategory.VendorSupplierExpectations:
      return "Items where supplier, lead time, or replenishment configurations don't reflect real world purchasing behavior.";
    case ValidationRuleTemplateCategory.DefaultDailyWorkflow:
      return 'Rules that power the daily workflow by default.';
    default:
      // Default to most popular
      return 'The most adopted and high-impact rules across top-performing teams. A great place to start.';
  }
};

// Copies a runnable sql to the clipboard
export async function handleOnCopy(sql: string) {
  const templatedSql = `${INPUT_SQL_CTE}\n${sql}`;
  const copyableSql = templatedSql.replace(/@DB_SCHEMA/g, `recurrency`).replace(/@ERP_SCHEMA/g, `erp`);
  copy(copyableSql);
}

export function getCategoryDisplayName(category: string): string {
  switch (category) {
    case ValidationRuleCategories.Reports:
      return 'Reports';
    case ValidationRuleCategories.Overrides:
      return 'Overrides';
    case ValidationRuleCategories.DailyWorkflow:
      return 'Daily Workflow';
    case ValidationRuleCategories.MinMaxAutomation:
      return 'Min/Max Automation';
    default:
      return 'Planning Filters';
  }
}
